import { ok, err } from '@xlearn/common';
import { TimeInterval, parseTimeInterval,  } from '../../api';
import { SchemaError, ErrorCode } from '../schema-engine';

export function setSessionTime(current: TimeInterval, value: string) {
  const parsed = parseTimeInterval(value);
  if (parsed === false) {
    return err(new SchemaError(
      ErrorCode.incorrectDataType,
      `Unable to parse timeinterval value '${value}'`));
  }

  return ok(parsed);
}
